<template>
    <div @click="showPopover">
        <el-input
            v-if="!treeSelect.multiple"
            ref="input"
            class="xx-treeselect__filterinput"
            v-model="label"
            :validate-event="false"
            :clearable="treeSelect.clearable && !!this.label"
            :size="$attrs.size"
            :disabled="$attrs.disabled"
            :placeholder="treeSelect.placeholder"
            :suffix-icon="inputIcon"
            @input="changeFilter"
            @clear="clearValue"
        ></el-input>
        <tag-wrapper v-else ref="tagWrapper" :data="tagData" v-bind="$attrs"></tag-wrapper>
    </div>
</template>
<script>
import TagWrapper from './TagWrapper';

export default {
    components: {
        TagWrapper
    },
    props: {
        // 选中的节点的数据
        tagData: {
            required: true
        }
    },
    inject: ['treeSelect'],
    data() {
        return {
            timeout: null,
            label: ''
        };
    },
    watch: {
        tagData: {
            handler(val) {
                this.label = (val && val[this.treeSelect.innerNodeConfig.label]) || this.$attrs.value;
            },
            deep: true
        }
    },
    computed: {
        inputIcon() {
            if (this.treeSelect.popoverVisible) {
                return 'el-icon-arrow-up';
            }
            return 'el-icon-arrow-down';
        }
    },
    methods: {
        changeFilter(val) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.$emit('filter', val);
            }, 500);
        },
        showPopover() {
            // 如果是单选，并且不可用状态，不触发弹窗
            if (!this.treeSelect.multiple && this.$attrs.disabled) return;
            if (!this.$attrs.disabled) {
                if (!this.treeSelect.multiple) {
                    this.$refs.input.select();
                } else {
                    this.$refs.tagWrapper.$refs.input.select();
                }
            }
            this.treeSelect.showPopover();
        },
        clearKeyword() {
            if (this.treeSelect.multiple) {
                this.$refs.tagWrapper.clearKeyword();
            } else {
                this.label = (this.tagData && this.tagData[this.treeSelect.innerNodeConfig.label]) || this.$attrs.value;
                this.changeFilter('');
            }
        },
        clearValue() {
            this.treeSelect.$refs.treeWrapper.clearValue();
        }
    }
};
</script>
